export const ExtMapping = {
    'img': ['jpg', 'jpeg', 'png', 'gif', 'bmp'],
    'zip': ['zip', '7z', 'rar', 'iso'],
    'doc': ["doc", "dot", "wps", "wpt", "docx", "dotx", "docm", "dotm"],
    'xls': ["xls", "xlt", "et", "xlsx", "xltx", "csv", "xlsm", "xltm"],
    'ppt': ["ppt", "pptx", "pptm", "ppsx", "ppsm", "pps", "potx", "potm", "dpt", "dps"],
    'txt': ['txt', 'text'],
    'pdf': ['pdf'],
    'pom': ['pom'],
    'pof': ['pof']
}
export const accountApiUrl = 'https://account.wps.com'
export const baseApiUrl = 'https://drive.wps.com'
export const pageCount = 30
export const editable = [
    "doc", "dot", "wps", "wpt", "docx", "dotx", "docm", "dotm",
    "xls", "xlt", "et", "xlsx", "xltx", "csv", "xlsm", "xltm",
    "ppt", "pptx", "pptm", "ppsx", "ppsm", "pps", "potx", "potm", "dpt", "dps"
]
export const share = true
export const actions = {
   	sharedFile: [{
        name: 'SendToFriend',
        method: () => handleActions("share")
   	},{
        name: 'Delete',
        method: () => handleActions("delete")
   	}],
    myFile: [{
        name: "SendToFriend",
    },{
        name: "Copy",
    },{
        name: "Move",
    },{
        name: "Rename",
    },{
        name: "Delete",
    }]
}
export const shareAddress = 'https://s.docworkspace.com'
export const publicWeboffice = process.env.KAE_PUBLIC_WEBOFFICE


// WEBPACK FOOTER //
// ./src/config/index.js